<app-agricola-navbar></app-agricola-navbar>

<div class="search-container">
  <div class="search-content">
    <!-- Title -->
    <h1 class="search-title">Búsqueda de cliente</h1>

    <!-- Search Form -->
    <form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="search-form">
      <!-- Radio Buttons for Search Type -->
      <fieldset class="radio-group">
        <legend class="visually-hidden">Tipo de búsqueda</legend>
        <label
          class="radio-option"
          *ngFor="let type of searchTypes"
          [class.selected]="selectedSearchType === type.value">
          <input
            type="radio"
            formControlName="searchType"
            [value]="type.value"
            [attr.disabled]="isLoading ? '' : null"
            class="radio-input">
          <span class="radio-label">{{ type.label }}</span>
        </label>
      </fieldset>

      <!-- Search Input Field -->
      <div class="search-input-group">
        <div
          class="search-input-wrapper"
          appSisFieldLoading
          [loading]="isLoading"
          [loadedKey]="searchLoadedKey"
          loadedMessage="Resultado de búsqueda cargado"
          [loadFailed]="searchLoadFailed"
          [class.correct]="isSearchValueCorrect"
          [class.invalid]="!!searchValueError">
          <img src="assets/agricola/buscar.svg" alt="" aria-hidden="true" class="search-icon" />
          <input
            type="text"
            formControlName="searchValue"
            class="search-input"
            [attr.aria-invalid]="searchValueError ? 'true' : null"
            [attr.aria-describedby]="searchValueError ? 'search-value-error' : 'search-character-hint'"
            [attr.disabled]="isLoading ? '' : null"
            [placeholder]="getCurrentSearchType()?.placeholder || 'Buscar'"
            [maxlength]="getCurrentSearchType()?.maxLength || 100">
          <svg
            *ngIf="isSearchValueCorrect"
            class="check-icon"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true">
            <circle cx="10" cy="10" r="9" stroke="currentColor" stroke-width="1.5"/>
            <path d="M6 10l3 3 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span *ngIf="searchValueError; else characterHint" id="search-value-error" class="search-error">{{ searchValueError }}</span>
        <ng-template #characterHint>
          <span id="search-character-hint" class="character-hint">{{ getCharacterCount() }}</span>
        </ng-template>
      </div>

      <!-- Search Button -->
      <button
        type="submit"
        class="search-button"
        [disabled]="searchForm.invalid || isLoading">
        {{ isLoading ? 'BUSCANDO...' : 'BUSCAR' }}
      </button>
    </form>
  </div>
</div>
